import { SVGProps } from 'react'

import { CameraCardTheme } from '../../types'
import styles from './CameraCardFolderMask.module.scss'
import { CAMERA_CARD_MASKS_PATHS } from './constants'
import { generateMaskImage } from './utils'

type Props = { maskType: CameraCardTheme } & SVGProps<SVGSVGElement>

export const CameraCardFolderMask = ({
  maskType,
  children,
  ...props
}: Props) => {
  const maskPaths = CAMERA_CARD_MASKS_PATHS[maskType]
  const maskImage = generateMaskImage(maskPaths)

  return (
    <div className={styles.container}>
      <svg
        width="298rem"
        height="257rem"
        viewBox="0 0 298 257"
        fill="none"
        className={styles.folder}
        {...props}
      >
        <path d={maskPaths} stroke="url(#paint0_linear)" strokeWidth="1.11" />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="288.07"
            y1="20.72"
            x2="414.85"
            y2="212.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#7F7F7F" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
      <div
        className={styles.content}
        style={{ maskImage, WebkitMaskImage: maskImage }}
      >
        {children}
      </div>
    </div>
  )
}
